import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableId = 'tableUsers';
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
    }
}

export class OfCustomerPage extends PageBase<IndexPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    constructor(options: IndexPageOptions) {
        super(options);

        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            columns: [
                {
                    data: "UserName",
                    className: "bold",
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkUsername${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: "IsEnabled",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                },              
                {
                    data: '',
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>${options.localizer.DetailsLink}</a>`)
                }
            ]
        };
    }

    init(): void {
        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/FrontofficeUsers/OfCustomerPage.ts
 **/